import { makeStyles } from 'tss-react/mui';

export const useProductCodeSearchStyles = makeStyles()((theme) => ({
  mobileOverlay: {
    position: 'absolute',
    top: 0,
    left: theme.spacing(1),
    right: theme.spacing(1),
    bottom: 0,
    zIndex: theme.zIndex.drawer + 2,
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
  },
}));
